import { faqContent, featuresContent } from "@/data/landingpage";
import { Faqs } from "@/features/Faqs";
import { Features } from "@/features/Features";
import { LandingHero } from "@/features/Hero";
import { Partners } from "@/features/Partners";
import { LandingPageLayout } from "@/layouts/LandingPageLayout";

export default function HomePage() {
  return (
    <LandingPageLayout>
      <LandingHero />
      <Features content={featuresContent} />

      <Faqs content={faqContent} />

      <Partners />
    </LandingPageLayout>
  );
}
